import { NgIf, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';
import { CommonService } from '../../../../services/common.service';
import { MessageService } from 'primeng/api';
import { NotificationService } from '../../../../services/notification.service';
@Component({
    selector: 'app-manage-sections',
    imports: [NextPage, TableModule, NgIf, NgClass, ButtonModule, FormsModule],
    templateUrl: './manage-sections.component.html',
    styleUrl: './manage-sections.component.scss'
})
export class ManageSectionsComponent {
  sectionData: any = [];
  exportData: any = [];
  newSectionName = '';
  newSectionAbbr = '';
  newMaximoCode = '';

  isLoading: boolean = false;
  errorData: boolean = false;
  SaveSuccess: boolean = false;
  constructor(private adminService: AdminService, private commonService: CommonService, private messageService: NotificationService) {
    this.isLoading = true;
    this.setSectionData();
  }

  setSectionData() {
    this.adminService.getAllUserInteractions('ManageSections').subscribe((response: any) => {
      this.sectionData = response;
      this.setExportData(response);
      this.processData();
    });
  };

  changeNav(){
    this.SaveSuccess = false;
  }

  setExportData(data: any) {
    this.exportData = data.map((item: any) => ({
      RecID: item.RecID,
      FacilityID: item.FacilityID,
      SectionName: item.SectionName,
      SectionMaximo : item.SectionMaximo,
      SectionAbbr: item.SectionAbbr,
      SectionRetired: item.SectionRetired
    }));
  }

  processData() {
    this.sectionData.forEach((section: any) => {
      if (section.SectionRetired == 'True') {
        section.status = 'Inactive';
        section.buttonName = 'Unretire'
      } else {
        section.status = 'Active';
        section.buttonName = 'Retire'
      }
    });
    this.isLoading = false;
  }
  retire(row: any) {
    if (confirm(`Are you sure you want to update a record?`)) {

    let payload = {
      "region": "Section",
      "recID": row.RecID,
      "retired": row.SectionRetired == 'True' ? false : true
    }
    this.adminService.RETIREUSERINTERACTION(payload).subscribe({
      next: (message: any) => {
        this.messageService.showSuccess( message.message );
        this.setSectionData();
      }
    })
  }
  }

  addSection() {
    this.errorData = false;
    this.SaveSuccess  = false;
    if(this.newMaximoCode == '' || this.newSectionName == '' || this.newSectionAbbr == ''){
      this.messageService.showError("Please fill all the fields" );
      this.errorData = true;
      return;
    }
    let payload = {
      region: "Section",
      data: {
        SectionName: this.newSectionName,
        SectionMaximo: this.newMaximoCode,
        SectionAbbr: this.newSectionAbbr,
        FacilityID: this.commonService.getCurrentFacilityId(),
      }
    }

     this.adminService.submitUserInteraction(payload).subscribe({
      next: (message: string) => {
        this.SaveSuccess = true;
        this.messageService.showSuccess(message);
        this.newSectionName = '';
        this.newMaximoCode = '';
        this.newSectionAbbr = '';
        this.setSectionData();
      }
    })

  }

  exportToExcel() {
    this.commonService.exportToExcel(this.exportData, 'TLRAdmin-Sections.xlsx','TLRAdmin-Sections');
    this.messageService.showSuccess("file downloaded successfully" );
  }
}
